exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".avatar-div[data-v-54d99af9]{width:100%;height:80px;text-align:center;padding-top:30px;span{width:70px;height:70px;line-height:70px}}.el-row[data-v-54d99af9]{margin-bottom:0}.el-col[data-v-54d99af9]{border-radius:4px}.bg-purple-dark[data-v-54d99af9]{background:#99a9bf}.bg-purple[data-v-54d99af9]{border:1px solid #f3f3f3;padding:10px;box-sizing:border-box}.grid-content[data-v-54d99af9]{border-radius:4px;min-height:715px}.row-bg[data-v-54d99af9]{padding:10px 0;background-color:#f9fafc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54d99af9","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/components/Personal.vue
// module id = 249
// module chunks = 0